import React from 'react';

import { AnalysisParameters, BaseAnalysisParameters } from '@models/AnalysisParameters';
import Experiment from '@models/Experiment';
import Plot from '@models/Plot';

import AnalysisGroupsField from '../assaySummary/AnalysisGroupsField';
import AnalysisVariablesMultiSelectField from '../assaySummary/AnalysisVariablesMultiSelectField';

type Props = {
    experiment: Experiment;
    plot: Plot;
    analysisParameters: AnalysisParameters | null;
};
const SampleSummaryCategoricalAnalysisFormFields = ({ experiment, analysisParameters, plot }: Props) => {
    return (
        <div className="space-y-8">
            <div className="mt-4">
                <AnalysisVariablesMultiSelectField
                    variables={(analysisParameters as BaseAnalysisParameters).variables}
                />
                <AnalysisGroupsField plot={plot} experiment={experiment} />
            </div>
        </div>
    );
};

export default SampleSummaryCategoricalAnalysisFormFields;
